import { IAgentInfo } from "@/interfaces";


export class AgentInfo implements IAgentInfo {
    
}